import { GenericObject, copyFields } from '@synergy/models';

import { ProductSnapshot } from '../../../../common/models/product-snapshot';

export class ConverterPositionItem extends ProductSnapshot {
    public id!: number;
    public secondaryText?: string;
    public isSelected!: boolean;
    public converterInfo?: unknown;
    public position?: number;

    public static fromPlainObject(object: GenericObject): ConverterPositionItem {
        const item = new ConverterPositionItem();

        // Import own keys
        copyFields(object, item);

        // Import from base class (snapshot)
        const productSnapshot = ProductSnapshot.fromPlainObject(object);

        // Overwrite own keys with base keys
        copyFields(productSnapshot, item);

        return item;
    }
}
